import React, {useState, useEffect} from "react";
import Countdown from "react-countdown";
import { useSaleCountdown } from "./SaleCountdownProvider";
import "./SaleCountDown.css";
import Skeleton from "@mui/material/Skeleton";

export default function SaleCountDown() {
    const { saleStartTime, saleEndTime, saleMessage, saleButtonName, saleLink} = useSaleCountdown();
    const [currentTime, setCurrentTime] = useState(Date.now());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(Date.now());
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    // Agar sale nahi lagi ya sale khatam ho chuki hai toh kuch render na karein
    if (!saleStartTime || !saleEndTime || currentTime < saleStartTime || currentTime > saleEndTime) {
        return null;
    }

    // Handle button click with validation checks
    const handleButtonClick = () => {
        if (saleLink && saleLink.trim() !== "") {
            // Same window mein open hoga (no new tab)
            window.location.href = saleLink;
        }
    };


    // Custom Renderer for Countdown
    const renderer = ({ days, hours, minutes, seconds }) => (
      <div className="sale-countdown-container">
        <h2 className="sale-message">{saleMessage}</h2>
        <div className="countdown-timer">
          <div className="time-box">
            <span className="time">{String(days).padStart(2, "0")}</span>
            <span className="label">DAYS</span>
          </div>
          <span className="colon">:</span>
          <div className="time-box">
            <span className="time">{String(hours).padStart(2, "0")}</span>
            <span className="label">HOURS</span>
          </div>
          <span className="colon">:</span>
          <div className="time-box">
            <span className="time">{String(minutes).padStart(2, "0")}</span>
            <span className="label">MINUTES</span>
          </div>
          <span className="colon">:</span>
          <div className="time-box">
            <span className="time">{String(seconds).padStart(2, "0")}</span>
            <span className="label">SECONDS</span>
          </div>
        </div>
        <button 
          className="shop-now"
          onClick={handleButtonClick}
          disabled={!saleLink || saleLink.trim() === ""} // Disable button if no link
        >
          {saleButtonName}
        </button>
      </div>
    );
  
    return (
        <>
          {saleEndTime ? (
            <Countdown date={saleEndTime} renderer={renderer} />
          ) : (
            <div className="skeleton-container">
              <Skeleton variant="rectangular" width={'23%'} height={30} />
              <div className="timer-skeleton" >
                <div className="time-info-skeleton">
                  <Skeleton variant="rectangular" width={'100%'} height={60} />
                  <Skeleton variant="rectangular" width={'70%'} height={20} />
                </div>

                <div className="colon-skeleton">
                  <Skeleton variant="rectangular" width={'50%'} height={7} />
                  <Skeleton variant="rectangular" width={'50%'} height={7} />
                </div>

                <div className="time-info-skeleton">
                  <Skeleton variant="rectangular" width={'100%'} height={60} />
                  <Skeleton variant="rectangular" width={'70%'} height={20} />
                </div>

                <div className="colon-skeleton">
                  <Skeleton variant="rectangular" width={'50%'} height={7} />
                  <Skeleton variant="rectangular" width={'50%'} height={7} />
                </div>

                <div className="time-info-skeleton">
                  <Skeleton variant="rectangular" width={'100%'} height={60} />
                  <Skeleton variant="rectangular" width={'70%'} height={20} />
                </div>

                <div className="colon-skeleton">
                  <Skeleton variant="rectangular" width={'50%'} height={7} />
                  <Skeleton variant="rectangular" width={'50%'} height={7} />
                </div>

                <div className="time-info-skeleton">
                  <Skeleton variant="rectangular" width={'100%'} height={60} />
                  <Skeleton variant="rectangular" width={'70%'} height={20} />
                </div>
              </div>
              <Skeleton variant="rectangular" width={'15%'} height={48} className="btn-skeleton"/>
            </div>
          )}
        </>
    );
  }


// import React, { useState, useEffect } from "react";
// import Countdown from "react-countdown";
// import { db } from "../firebase/firebase";
// import { doc, onSnapshot } from "firebase/firestore";
// import "./SaleCountDown.css";

// export default function SaleCountDown() {
//   const [saleEndTime, setSaleEndTime] = useState(null);

//   useEffect(() => {
//     const saleRef = doc(db, "sales", "saleCountdown");

//     // Firestore se real-time data fetch karo
//     const unsubscribe = onSnapshot(saleRef, (doc) => {
//       if (doc.exists()) {
//         const firebaseTime = doc.data().saleEndTime.toDate().getTime();
//         setSaleEndTime(firebaseTime);
//       }
//     });

//     return () => unsubscribe(); // Component unmount hone pe clean-up
//   }, []);

//   // Custom Renderer for Countdown
//   const renderer = ({ days, hours, minutes, seconds }) => {
//     return (
//       <div className="sale-countdown-container">
//         <h2>⏳ Hurry up! Sale ends in</h2>
//         <div className="countdown-timer">
//           <div className="time-box">
//             <span className="time">{days}</span>
//             <span className="label">DAYS</span>
//           </div>
//           <span className="colon">:</span>
//           <div className="time-box">
//             <span className="time">{hours}</span>
//             <span className="label">HOURS</span>
//           </div>
//           <span className="colon">:</span>
//           <div className="time-box">
//             <span className="time">{minutes}</span>
//             <span className="label">MINUTES</span>
//           </div>
//           <span className="colon">:</span>
//           <div className="time-box">
//             <span className="time">{seconds}</span>
//             <span className="label">SECONDS</span>
//           </div>
//         </div>
//         <button className="shop-now">🛒 Shop Now</button>
//       </div>
//     );
//   };

//   return (
//     <>
//       {saleEndTime ? <Countdown date={saleEndTime} renderer={renderer} /> : <p>Loading...</p>}
//     </>
//   );
// }



// import React, { useState, useEffect } from "react";
// import Countdown from "react-countdown";
// import { db } from "../firebase/firebase";
// import { doc, onSnapshot } from "firebase/firestore";
// import "./SaleCountDown.css";

// export default function SaleCountDown() {
//   const [saleEndTime, setSaleEndTime] = useState(null);

//   useEffect(() => {
//     const saleRef = doc(db, "sales", "saleCountdown");

//     // Firestore se real-time data fetch karo
//     const unsubscribe = onSnapshot(saleRef, (doc) => {
//       if (doc.exists()) {
//         const firebaseTime = doc.data().saleEndTime.toDate().getTime();
//         setSaleEndTime(firebaseTime);
//       }
//     });

//     return () => unsubscribe(); // Component unmount hone pe clean-up
//   }, []);

//   return (
//     <div className="sale-countdown-container">
//       <h2>Sale Ends In:</h2>
//       {saleEndTime ? (
//         <Countdown date={saleEndTime} />
//       ) : (
//         <p>Loading...</p>
//       )}
//     </div>
//   );
// }


// import React, { useState, useEffect } from "react";
// import "./SaleCountDown.css";

// export default function SaleCountDown() {
//   // 🕒 Set End Date (Change for Testing)
//   //   const saleEndTime = new Date("2024-12-31 23:59:59").getTime(); //set timer
//   //   const saleEndTime = new Date().getTime() + 2 * 24 * 60 * 60 * 1000; // 2 days from now
//   const saleEndTime = new Date(new Date().getTime() + 1 * 60 * 1000).getTime(); //1 second


//   // ⏳ Function to calculate remaining time
//   const calculateTimeLeft = () => {
//     const now = new Date().getTime();
//     const difference = saleEndTime - now;

//     if (difference <= 0) {
//       return { days: "00", hours: "00", minutes: "00", seconds: "00" };
//     }

//     return {
//       days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, "0"),
//       hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, "0"),
//       minutes: String(Math.floor((difference / (1000 * 60)) % 60)).padStart(2, "0"),
//       seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, "0"),
//     };
//   };

//   // 🕰️ State for countdown
//   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setTimeLeft(calculateTimeLeft());
//     }, 1000); // Har second update

//     return () => clearInterval(timer); // Cleanup on unmount
//   }, []);

//   return (
//     <div className="sale-countdown-container">
//       <h2>Hurry up! Sale ends in</h2>
//       <div className="countdown-timer">
//         <span>{timeLeft.days}</span> : <span>{timeLeft.hours}</span> :{" "}
//         <span>{timeLeft.minutes}</span> : <span>{timeLeft.seconds}</span>
//       </div>
//       <p>Days &nbsp;&nbsp; Hours &nbsp;&nbsp; Minutes &nbsp;&nbsp; Seconds</p>
//       <button className="shop-now">Shop now</button>
//     </div>
//   );
// }







// import React, { useState, useEffect } from 'react';
// import './SaleCountDown.css';

// export default function SaleCountDown() {
//   // Sale ki expiry date set karo (yyyy-mm-dd hh:mm:ss)
//   const saleEndTime = new Date("2024-12-31 23:59:59").getTime();
  
//   const [timeLeft, setTimeLeft] = useState({
//     days: "00",
//     hours: "00",
//     minutes: "00",
//     seconds: "00"
//   });

//   useEffect(() => {
//     const timer = setInterval(() => {
//       const now = new Date().getTime();
//       const difference = saleEndTime - now;

//       if (difference > 0) {
//         const days = String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, "0");
//         const hours = String(Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, "0");
//         const minutes = String(Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
//         const seconds = String(Math.floor((difference % (1000 * 60)) / 1000)).padStart(2, "0");

//         setTimeLeft({ days, hours, minutes, seconds });
//       } else {
//         clearInterval(timer);
//       }
//     }, 1000);

//     return () => clearInterval(timer);
//   }, [saleEndTime]);

//   return (
//     <div className="sale-countdown-container">
//       <h2>Hurry up! Sale end in</h2>
//       <div className="countdown-timer">
//         <div className="time-box">
//           <span className="time">{timeLeft.days}</span>
//           <span className="label">DAYS</span>
//         </div>
//         <span className="colon">:</span>
//         <div className="time-box">
//           <span className="time">{timeLeft.hours}</span>
//           <span className="label">HOURS</span>
//         </div>
//         <span className="colon">:</span>
//         <div className="time-box">
//           <span className="time">{timeLeft.minutes}</span>
//           <span className="label">MINUTES</span>
//         </div>
//         <span className="colon">:</span>
//         <div className="time-box">
//           <span className="time">{timeLeft.seconds}</span>
//           <span className="label">SECONDS</span>
//         </div>
//       </div>
//       <button className="shop-now">Shop Now</button>
//     </div>
//   );
// }
